<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
[cdkConnectedOverlayPositions]="positionPairs"
                            [cdkConnectedOverlayDisableClose]="false"
                            (detach)="salvarConfig()">
  <div class ="tab-order">
    <div cdkDropList class="list-order" (cdkDropListDropped)="drop($event)">
      <div class="list-order-box" *ngFor="let item of realMarketPlaceTabs" cdkDrag>
        <div class="list-order-custom-placeholder" *cdkDragPlaceholder></div>
          <div  class="{{item.iconClass}}" >
            <generic-icon [iconName]="item.iconName" type="custom"></generic-icon>
          </div>
          <span>
            {{item.name}}
          </span>
      </div>
    </div>
  </div>
</ng-template>

<div class="content-tabs">
  <nz-spin class="tabs-spin" [nzSpinning]="loading" nzSize="large">
    <nz-tabs class="custom-tabs" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (contextmenu)="onRightClick($event)">
      <ng-container *ngFor="let item of realMarketPlaceTabs;let index = index" >
        <nz-tab *ngIf="item.canAccess" [nzTitle]="tabTitleTpl">
            <ng-template #tabTitleTpl>
              <div class="{{item.iconClass}}" [nz-tooltip]="item.name">
                <generic-icon [iconName]="item.iconName" type="custom"></generic-icon>
              </div>
            </ng-template>
            <!-- lazy: o conteúdo (e as buscas do datagrid) só é criado quando a aba é aberta -->
            <ng-template nz-tab>
              <div class="{{item.className}}">
                <generic-marketplace-tab [parentRow]="row" [component]="item.componentName" [entityName]="item.entityName" [templateId]="item.templateId"></generic-marketplace-tab>
              </div>
            </ng-template>
          </nz-tab>
        </ng-container>
  </nz-tabs>
  </nz-spin>
</div>
